import axios from 'axios'
import { API_CONFIG } from '@/config'

/**
 * Shared axios instance for catalog <-> fixshop webview API.
 *
 * Поддерживаются два режима авторизации:
 * 1. Telegram WebApp (Mini App) — X-Telegram-Init-Data header (автоматически,
 *    когда каталог открыт через кнопку бота).
 * 2. Browser mode — Authorization: Bearer <jwt>, хранится в localStorage.
 *    JWT выдаётся после входа через Telegram Login Widget.
 *
 * Если нет ни initData ни токена — запросы уходят без auth заголовков.
 * Публичные эндпоинты (/products, /categories) отвечают без авторизации.
 * Защищённые (/me, /orders) вернут 401.
 */

const tg = (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp) || null

if (tg && typeof tg.ready === 'function') {
  try { tg.ready() } catch (e) { /* noop */ }
}
if (tg && typeof tg.expand === 'function') {
  try { tg.expand() } catch (e) { /* noop */ }
}

export const initData = (tg && tg.initData) || ''
export const tgUser = (tg && tg.initDataUnsafe && tg.initDataUnsafe.user) || null
export const isInsideTelegram = Boolean(initData)

// --- Browser JWT helpers ---
const JWT_KEY = 'tg_webview_jwt'
export function getBrowserToken() { return localStorage.getItem(JWT_KEY) || '' }
export function setBrowserToken(t) { localStorage.setItem(JWT_KEY, t) }
export function clearBrowserToken() { localStorage.removeItem(JWT_KEY) }

const api = axios.create({
  baseURL: API_CONFIG.baseUrl,
})

api.interceptors.request.use((cfg) => {
  if (initData) {
    // Telegram WebApp — подписанный initData
    cfg.headers['X-Telegram-Init-Data'] = initData
  } else {
    const token = getBrowserToken()
    if (token) {
      cfg.headers['Authorization'] = `Bearer ${token}`
    }
  }
  return cfg
})

export default api
